import React, { ReactNode } from 'react'

import './LoginController.less'

interface LoginAppComponentProps {
  logo: ReactNode
  appName: string
  onClick: () => void
  classname?: string
  testId?: string
}

const LoginAppComponent: React.FC<LoginAppComponentProps> = ({ logo, appName, onClick, classname, testId }) => {
  return (
    <div data-testid={testId} className={`${classname} app_to_login cursor_pointer m-24`} onClick={() => onClick()}>
      <div>
        <div>{logo}</div>
        <div className="flex flex__center">
          <h5>{appName}</h5>
        </div>
      </div>
    </div>
  )
}

export default LoginAppComponent
